import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-loader',
    imports: [],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);
  protected isLoading = this.loaderService.isLoading;
}
